import { Box, Text, Stack, Center, Button } from "@mantine/core";
import { Title } from "../components";
import { CONTACT } from "../demo";

type Props = {
  id: string;
};

export default function Pricing({ id }: Props) {
  return (
    <section id={id}>
      <Title
        title="服務收費"
        description="以下收費只供參考，立即聯絡我們索取報價。"
      />
      <Box
        sx={(theme) => ({
          padding: theme.spacing.xl,
          borderRadius: theme.radius.md,
          backgroundColor: theme.white,
          marginBottom: theme.spacing.sm,
        })}
      >
        <Center>
          <Stack align="center" spacing={"xs"}>
            <Text c="dimmed" ta="center" mt="md">
              ⭐ 清洗掛牆分體機$650/部
            </Text>
            <Text c="dimmed" ta="center" mt="md">
              ⭐ 清洗掛牆分體機3部或以上劃一收費$600/部
            </Text>
            <Text c="dimmed" ta="center" mt="md">
              ⭐ 清洗室外散熱機加$200/部
            </Text>
            <Text c="dimmed" ta="center" mt="md">
              ❗ 淨清洗室外散熱機$500/部
            </Text>
            <Button
              mt={10}
              variant="outline"
              size="lg"
              disabled={!CONTACT.whatsappHref}
              sx={{
                borderColor: "#928643",
                color: "#928643",
                "&:hover": {
                  backgroundColor: "#fffcec",
                },
              }}
              onClick={() => {
                if (!CONTACT.whatsappHref) return;
                window.location.href = CONTACT.whatsappHref;
              }}
            >
              索取報價
            </Button>
          </Stack>
        </Center>
      </Box>
    </section>
  );
}
